<div class="modal" [style.height]="height+'px' ?? 'initial'" [style.width]="width+'px'?? 'initial'">
  <div class="loading" [ngClass]="{active:loading}">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         style="shape-rendering: auto;" width="200px"
         height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <circle cx="50" cy="50" r="32" stroke-width="8" stroke="#559765"
              stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round">
        <animateTransform attributeName="transform" type="rotate" dur="2.8571428571428568s" repeatCount="indefinite"
                          keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
      </circle>
      <circle cx="50" cy="50" r="23" stroke-width="8" stroke="#197973"
              stroke-dasharray="36.12831551628262 36.12831551628262" stroke-dashoffset="36.12831551628262" fill="none"
              stroke-linecap="round">
        <animateTransform attributeName="transform" type="rotate" dur="2.8571428571428568s" repeatCount="indefinite"
                          keyTimes="0;1" values="0 50 50;-360 50 50"></animateTransform>
      </circle>
    </svg>
  </div>
  <div class="heading" *ngIf="!disable_exit">
    <h2>{{heading}}</h2>
    <div class="actions">
      <div *ngFor="let action of actions" (click)="actionFunc(action)" [innerHtml]="action!.label"></div>
      <svg (click)="toggle()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
           stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </div>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
<div (click)="toggle()" class="overlay"></div>
